import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { Store, Form, Field } from 'react-formality'
import connectPropTypes from './utilities/connectPropTypes'
import getField from './utilities/Data/getField'
import getImageSrcByResolution from './utilities/getImageSrcByResolution'
import userNameRules from './utilities/Data/User/userNameRules'
import UploadImage from './components/UploadImage'
import errorTypes from './enums/errorTypes'
import messageTypes from './enums/messageTypes'

import styles from './EditInfo.icss'

class EditInfo extends React.Component {
	constructor(props) {
		super(props)
		const { fullName, userName, instagramHandle, firstName, lastName, bio, link } = props.user.userProfile
		const userProfile = { fullName, userName, instagramHandle, firstName, lastName, bio, link }

		this.state = {
			values: {},
			store: new Store(userProfile,
				(values) => {
					if (this.mounted) {
						this.setState({ values })
					}
				})
		}
		this.form = React.createRef()
		this.onSubmit = this.onSubmit.bind(this)
		this.handleUploadedImage = this.handleUploadedImage.bind(this)
		this.handleUploadImageError = this.handleUploadImageError.bind(this)
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Your info') })
		this.props.appShowBottomBar(false)
		this.props.appShowBottomNavBar(true)
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
		this.props.appBottomNavBarHandleClick(() => this.form.current.submit())
		this.mounted = true
	}

	componentDidUpdate() {
		if (!this.props.pageHasLoaded) {
			this.props.appPageLoaded(true)
		}
	}

	componentWillUnmount() {
		this.mounted = false
	}

	onSubmit(e, values, isValid) {
		if (isValid) {
			this.props.userProfileUpdate({ goBack: true, userProfile: { ...values }, history: this.props.history })
		} else {
			this.setState({ values })
		}
	}

	handleUploadedImage(url) {
		const profileImage = url
		this.props.userProfileUpdateProfilePicture({ profileImage })
		this.props.userProfileSetUploadedImage({ url })
	}

	handleUploadImageError() {
		this.props.appMessage(messageTypes.ERROR, this.context.translate('User profile picture upload failed'), errorTypes.UNKNOWNERROR)
	}

	render() {
		const userProfile = getField(this.props.user, 'userProfile')
		if (!userProfile) {
			return null
		}
		const profileImageSrc = this.props.currentUserProfileImage || getImageSrcByResolution({ content: userProfile.images, divisor: 2 }) || userProfile.profileImage

		return (
			<section>
				<div className={styles.surround}>
					<Form store={this.state.store} onSubmit={this.onSubmit} ref={this.form}>
						<h2>{this.context.translate('Tell us about yourself.')}</h2>
						<Field
							component={TextField}
							name="fullName"
							className={styles.nameText}
							placeholder={this.context.translate('What is your full name?')}
							label={this.context.translate('Full Name')}
							value={this.state.values.fullName}
							fullWidth
							validate={{
								presence: true
							}}
						/>
						<Field
							component={TextField}
							name="userName"
							disabled
							placeholder={this.context.translate('Your username')}
							label={this.context.translate('Username')}
							value={this.state.values.userName}
							fullWidth
							validate={{
								presence: true
							}}
						/>
						<Field
							component={TextField}
							name="firstName"
							className={styles.nameText}
							placeholder={this.context.translate('What is your first name?')}
							label={this.context.translate('First Name')}
							value={this.state.values.firstName}
							fullWidth
						/>
						<Field
							component={TextField}
							name="instagramHandle"
							className={styles.nameText}
							placeholder={this.context.translate('What is your Instagram handle?')}
							label={this.context.translate('Instagram handle')}
							value={this.state.values.instagramHandle}
							fullWidth
							inputProps={{
								maxLength: 30
							}}
							validate={{
								formats: {
									rules: userNameRules
								},
								length: {
									maximum: 30,
									tooLong: this.context.translate('can be up to 30 characters')
								}
							}}
						/>
						<Field
							component={TextField}
							name="lastName"
							className={styles.nameText}
							placeholder={this.context.translate('What is your surname?')}
							label={this.context.translate('Surname')}
							value={this.state.values.lastName}
							fullWidth
						/>
						<Field
							component={TextField}
							name="bio"
							placeholder={this.context.translate('A few words about yourself')}
							label={this.context.translate('Bio (max 1000 chars)')}
							value={this.state.values.bio}
							fullWidth
							multiline
							validate={{
								length: { maximum: 1000 }
							}}
						/>
						<Field
							component={TextField}
							name="link"
							placeholder={this.context.translate('A link')}
							label={this.context.translate('Link')}
							value={this.state.values.link}
							//	Override the value of the link
							onBlur={() => {
								const values = this.state.values
								let link = values.link
								if (link && link !== '') {
									if (link.indexOf('http') !== 0) {
										link = `https://${link}`
										this.setState({ values: { ...values, link } })
										this.state.store.set('link', link)
									}
									this.state.store.fieldRefs.link.validate()
								}
							}}
							fullWidth
							validate={{
								url: true
							}}
						/>
					</Form>
					<div className={styles.profilePictureSurround}>
						{profileImageSrc && (
							<div className={styles.profilePicture} style={{ backgroundImage: `url(${profileImageSrc})` }} />
						)}
						<UploadImage
							classNames={{ surround: styles.buttonOnlySurround, wrapper: styles.buttonOnlyWrapper }}
							hintText=""
							buttonText={profileImageSrc ? this.context.translate('Change profile picture') : this.context.translate('Add profile picture')}
							uploadingText={this.context.translate('Uploading picture')}
							uploadedText={this.context.translate('Profile picture uploaded')}
							saveUploadedImage={this.handleUploadedImage}
							errorHandler={this.handleUploadImageError}
							imgInline={false}
						/>
					</div>
				</div>
			</section>
		)
	}
}

EditInfo.contextTypes = {
	translate: PropTypes.func
}

EditInfo.propTypes = {
	userProfileSetUploadedImage: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	currentUserProfileImage: PropTypes.string,
	appHeading: PropTypes.func.isRequired,
	appPageLoaded: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appMessage: PropTypes.func.isRequired,
	userProfileUpdateProfilePicture: PropTypes.func.isRequired,
	userProfileUpdate: PropTypes.func.isRequired,
	pageHasLoaded: PropTypes.bool.isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
}

EditInfo.defaultProps = {
	currentUserProfileImage: undefined
}

export default connectPropTypes(EditInfo)



// WEBPACK FOOTER //
// ./src/EditInfo.jsx